import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
class HelpPanel extends React.Component {   

    constructor(props){
        super(props);
        this.setBodyScroll = this.setBodyScroll.bind(this);
    }
    componentWillMount(){ }
    
    componentDidMount(){
        this.setBodyScroll(this.props);
    }

    componentWillReceiveProps(newProps){
       this.setBodyScroll(newProps);
    }

    setBodyScroll(props){
        
    }
    render(){
    if(!this.props.visible) return null;
    
        return (
            <div className="HelpPanel">
                <div>
                    <p className="HelpPanel-p">To play our interactive 50 states game, simply hit ‘Start Game’ to start the timer. The objective is to correctly name all 50 states capitals as quickly as you can.</p>
                    <p className="HelpPanel-p">For each state you will be given the name and outline of the state, along with four possible options. If you choose incorrectly, you will be given a small time penalty before you can choose another.</p>
                    <p className="HelpPanel-p">You can replay the game as many times as you like to get a better score. Keep in mind though that the options you‘ll be given are random, so you won’t get the same set of options twice.</p>
                    <Button color="#5597B8"  onClick={this.props.onClose}>BACK TO GAME</Button>
                </div>
                
                <style jsx>{`

                    .HelpPanel {
                        background: #f1e8c6;
                        position: absolute;
                        top:0px;
                        left:0px;
                        right:0px;
                        bottom:0px;
                        padding:30px!important;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                    
                    .HelpPanel-p {
                        margin-bottom:20px!important;
                        font-size:18px;

                        color: #494848;
                    }

                   

                    @media all and (max-width:768px){
                        .HelpPanel {
                            position: fixed;
                            overflow-y:auto;
                            z-index: 100;
                        }
                        .HelpPanel-p {
                        margin-bottom:20px!important;
                        font-size:15px!important;
                            
                        color: #494848;
                    }
                    }
                    
                `}</style>
            </div>
        )
    }
}

HelpPanel.propTypes = {
    
}

export default HelpPanel;